import { getSouthLocations } from "../structured-data-core";

export function getSouthStructuredData() {
  const url = "https://restorehair.com/locations/restore-south/";
  const description =
    "Restore your confidence with the top hair restoration team serving the South. Over 20,000 procedures.";
  return getSouthLocations(url, description);
}
